// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__rNRrs","wave":"spinner_wave__2GIvQ"};